import React from 'react';
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {hasPermission} from "./PermissionUtils";

const AccessItem = ({children, scopes, permissions}) => {
    if(hasPermission(permissions, scopes)) {
        return <>{children}</>;
    }

    return <></>;
}

const mapStateToProps = state => ({
    permissions: state.auth.user.user.company.permissions,
});

export default withRouter(connect(mapStateToProps, null)(AccessItem));